import {detectLanguage} from "modules/utils";
import * as process from "process";

export const LOCALE = detectLanguage();
export const GAME_ZONE_URL = process.env.REACT_APP_GZ_LINK || "";
export const PSF_URL = process.env.REACT_APP_PSF_LINK || "";
export const FANTASY_URL = process.env.REACT_APP_FANTASY_LINK || "";
export const OTHER_LANG_URL = process.env.REACT_APP_OTHER_LINK || "";
export const GZ_SITE_PATH = process.env.REACT_APP_SITE_PATH || "";
export const TEAM_QUIZ_URL = `${GAME_ZONE_URL}${GZ_SITE_PATH}/`;
export const SHARE_DISABLED = process.env.REACT_APP_DISABLE_SHARE === "true";
